import type {
  TransactionInitializeError,
  TransactionProcessError,
} from '@/graphql/saleor/api';

import type { FormattedError } from './common';
import { commonErrorCodeMessages } from './common';

/**
 * TransactionInitializeError & TransactionProcessError code match and currently
 * there is no reason to distinguish those 2.
 */
export const getTransactionErrorCodeMessage = (
  error: FormattedError<TransactionInitializeError | TransactionProcessError>,
) => {
  switch (error.code) {
    // eslint-disable-next-line no-fallthrough
    default:
      return commonErrorCodeMessages.genericPaymentError;
  }
};
